module.exports = __webpack_public_path__ + "img/m-suitpink.1ac8381b.svg";